import { render, staticRenderFns } from "./News.vue?vue&type=template&id=5f33e5d3&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "./News.vue?vue&type=style&index=0&id=5f33e5d3&scoped=true&lang=css&"
import style1 from "../assets/carousel.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33e5d3",
  null
  
)

export default component.exports